import { inject, Injectable, OnDestroy, signal } from "@angular/core";
import { UserModel } from "../models/user.model";
import { Router } from "@angular/router";
import { LocalStorageService } from "src/app/services/local-storage-service/local-storage.service";
import { LoginDialogComponent } from "../components/dialogs/login-dialog/login-dialog.component";
import { Dialog } from "@angular/cdk/dialog";
import { MatDialog } from "@angular/material/dialog";
import { AuthState } from "../models/auth.model";

export type UserType = UserModel | undefined;

@Injectable({
  providedIn: "root",
})
export class AuthUtilitiesService {
  private authLocalStorageToken = `auth-user`;
  // private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

  #localStorageService = inject(LocalStorageService);
  #router = inject(Router);
  #dialog = inject(MatDialog);

  constructor(private dialog: MatDialog) { }

  getToken() {
    const authData = JSON.parse(
      this.#localStorageService.getItem(this.authLocalStorageToken)!
    );
    return authData?.access_token;
  }

  logout() {
    document.location.href = "/home";
    this.#localStorageService.removeItem(this.authLocalStorageToken);
  }

  openLoginDialog() {
    const dialogRef = this.#dialog.open(LoginDialogComponent, {
      height: "auto",
      maxHeight: "90vh",
      minHeight: "30vh",
      disableClose: true
    });

    // dialogRef.afterClosed().subscribe((res) => {});
  }
}
